import { Heading, Span } from '@pandiafi/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Contract } from '../../../../common/validations'
import { CopyButton } from '../CopyButton'

interface CommonPaymentInformationProps {
  contract: Contract
}

export const CommonPaymentInformation: React.FC<
  CommonPaymentInformationProps
> = ({ contract }) => {
  const { t } = useTranslation(['payments'])
  return (
    <>
      <div className="flex justify-between mt-16">
        <div>
          <Heading element="h4" size="s" bold className="mb-2">
            {t('payments:paymentsBeneficiary')}
          </Heading>
          <Span>{contract.propertyCompanyName}</Span>
        </div>
        <CopyButton copyText={contract.propertyCompanyName || '?'} />
      </div>
      <div className="flex justify-between mt-4">
        <div>
          <Heading element="h4" size="s" bold className="mb-2">
            {t('payments:referenceNumber')}
          </Heading>
          <Span>{contract.referenceNumber}</Span>
        </div>
        <CopyButton copyText={contract.referenceNumber} />
      </div>
    </>
  )
}
